import InspectionProfile from "./InspectionProfile.container";

export default InspectionProfile;